import ListOfProjects from '../components/Projects/ListOfProjects/ListOfProjects'
import ListOfProjectByClient from '../components/Projects/ListOfProjectByClient/ListOfProjectByClient'
import ListOfRequests from '../components/Requests/ListOfRequests/ListOfRequests'
import TotalListOfProjects from '../components/TotalListOfProjects/TotalListOfProjects'

const routerArr = [
  {
    path: '/list-of-projects',
    name: 'ListOfProjects',
    component: ListOfProjects,
    meta: { access: 'crm.listOfProjects' }
  },
  {
    path: '/list-of-projects/client/:clientId',
    name: 'ListOfProjectByClient',
    component: ListOfProjectByClient,
    meta: { access: 'crm.listOfProjects' }
  },
  {
    path: '/list-of-projects/project/:projectId',
    name: 'ProjectCard',
    component: ListOfProjectByClient,
    meta: { access: 'crm.listOfProjects' }
  },
  {
    path: '/list-of-requests',
    name: 'ListOfRequests',
    component: ListOfRequests
  },
  {
    path: '/financial-planning',
    name: 'TotalListOfProjects',
    component: TotalListOfProjects,
    meta: { access: 'crm.listOfProjects' }
  }
]

if (process.env.NODE_ENV === 'development') {
  routerArr.push({
    path: '/',
    redirect: '/list-of-projects',
    name: 'index'
  })
}

export const ROUTER_LIST = routerArr



// WEBPACK FOOTER //
// ./src/constants/router.js